import React, { useState, useEffect } from "react";
import "./Style/Common.css";
import "./Style/FamilyLogin.css";
import "./Style/Header.css";
import "./Style/helplines.css";
import UserRed from "./Image/fr_userid_red.png";
import PassRed from "./Image/fr_password_red.png";
import FamilyLoginBg from "./Image/login_bg2.jpg";
import FamilyLoginTittle from "./Image/bar_titles_log_in.png";
import { useNavigate } from "react-router-dom";
import Loading from "../Common/Loading";
import { decryptPayload } from "../Common/utils/Decrypt";
import CryptoJS from "crypto-js";

const FamilyLogin: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const SchoolCode = params.get("C") || "DLR_KE_AU";
  // const Country = "Australia";
  // sessionStorage.setItem("Country", Country);

  const [userName, setuserName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [displayErrorMessage, setDisplayErrorMessage] =
    useState<boolean>(false);
  const [showHelplines, setShowHelplines] = useState<boolean>(false);
  const [tooltiptext, setTooltipText] = useState<string>("Show password");
  const [loading, setLoading] = useState<boolean>(false);

  // Account hold popup
  const [isAccountOnHold, setAccountOnHold] = useState(false);
  const [vacationStart, setVacationStart] = useState("");
  const [vacationEnd, setVacationEnd] = useState("");

  const navigate = useNavigate();
  const apiUrl =
    process.env.REACT_APP_DOCUMENT_LINK;

  useEffect(() => {
    document.body.style.backgroundImage = `url(${FamilyLoginBg})`;
    document.body.style.backgroundSize = "cover";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundPosition = "center center";
    document.body.style.backgroundAttachment = "fixed";
  }, []);

  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault();
    setErrorMessage("");
    setDisplayErrorMessage(false);

    if (!userName || !password) {
      setErrorMessage("Please enter both login ID and password");
      setDisplayErrorMessage(true);
      return;
    }

    try {
      setLoading(true);

      const secret =
        process.env.REACT_APP_FRONTEND_KEY || "orchid-sapphire-rocket-47!gloveX";

      const encryptedPassword = CryptoJS.AES.encrypt(
        password,
        CryptoJS.enc.Utf8.parse(secret),
        {
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
          iv: CryptoJS.enc.Utf8.parse(secret.slice(0, 16)),
        }
      ).toString();

      const response = await fetch(`${apiUrl}login/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: userName,
          password: encryptedPassword,
          SchoolCode,
        }),
      });

      const encryptedData = await response.json();
      const data = decryptPayload(encryptedData.data);

      if (data.country) {
        sessionStorage.setItem("Country", data.country);
      }

      if (!data) {
        setErrorMessage("Failed to decrypt server response.");
        setDisplayErrorMessage(true);
        setLoading(false);
        return;
      }

      if (!response.ok) {
        setErrorMessage(data.detail || data.error || "Login failed.");
        setDisplayErrorMessage(true);
        setLoading(false);
        return;
      }

      // Vacation Hold
      if (data.vacation?.on_vacation === true) {
        setAccountOnHold(true);
        setVacationStart(data.vacation.start);
        setVacationEnd(data.vacation.end);
        setLoading(false);
        return;
      }

      // Normal login
      localStorage.setItem("userName", userName);
      sessionStorage.setItem("FamilyCode", userName);
      sessionStorage.setItem("SchoolCode", SchoolCode);

      navigate("/Login/SelectUser");
    } catch {
      setErrorMessage("Network error. Please try again.");
      setDisplayErrorMessage(true);
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => {
      const newState = !prev;
      setTooltipText(newState ? "Hide password" : "Show password");
      return newState;
    });
  };

  const handlePasswordToggleKey = (e: React.KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      togglePasswordVisibility();
    }
  };

  const handleForgotPassword = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    window.open("/Login/ForgotPassword", "_blank");
  };

  const handleSchoolLogin = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    window.open("/Login/SchoolLogin", "_blank");
  };

  // =============================
  //  ACCOUNT ON HOLD SCREEN ONLY
  // =============================
  if (isAccountOnHold) {
    return (
      <div className="family-login">
        <div id="account_hold" className="account_hold_popup">

          <div id="account_hold_img"></div>

          <p>
            <span className="title_text">Account on Hold</span><br /><br />

            <span className="med_text">
              Your online tutoring is currently on hold from{" "}
              <b>{vacationStart}</b> to <b>{vacationEnd}</b>.
            </span>

            <br /><br />
            You'll be able to log in again once the hold period ends.<br />
            If you need assistance or want to resume earlier, please contact support.
            <br /><br /><br />
          </p>

          <div
            id="account_hold_ok_btn"
            className="general_btn two_btn"
            onClick={() => setAccountOnHold(false)}
          >
            <a id="account-hold">OK</a>
          </div>
        </div>
      </div>
    );
  }

  // =============================
  // NORMAL LOGIN SCREEN (default)
  // =============================
  return (
    <form id="form1" onSubmit={handleLogin}>
      <div className="family-login">
        <div id="main_top_container">
          <div
            id="helplines"
            className="helplinesT"
            style={{ display: showHelplines ? "block" : "none" }}
          >
            <p>
              <span className="title_text">Helplines</span>
              <br />
              <span className="med_text">Technical Support</span>
              <br />
              <b>1800 622 657</b>
              <br />
              Office Hours (9am - 6pm)
              <br /><br />
              <span className="med_text">Maths Wiz Helpline</span>
              <br />
              <b>1300 550 141</b>
              <br />
              WA: Mon–Thu 3pm–7pm
              <br />
              Other states: Mon–Thu 4pm–7:30pm
              <br /><br />
              <span className="med_text">Parent Helpline</span>
              <br />
              <b>1800 622 657</b>
              <br />
              Office Hours (9am - 6pm)
              <br /><br />
              <span className="med_text">Email Support</span>
              <br />
              tutor@kineticeducation.com.au
              <br />
              support@kineticeducation.com.au
            </p>

            <div id="hl_close_btn" className="general_btn two_btn">
              <div className="btn_text" onClick={() => setShowHelplines(false)}>
                Close
              </div>
            </div>
          </div>

          <div id="login_title_bar" className="section_container section_title_bar">
            <div
              id="bt_login"
              className="section_div bar_section"
              style={{ backgroundImage: `url(${FamilyLoginTittle})` }}
            >
              <p className="bar_title"></p>
            </div>
          </div>
        </div>

        <div id="Browser_info" className="browser_msg"></div>

        <div id="logindiv" className="section_container">
          <div id="login_logo"></div>

          <div id="login_form_box">
            <input
              type="text"
              className={`login_field login_userid ${errorMessage && !userName ? "red_input" : ""
                }`}
              placeholder="Login ID"
              style={
                errorMessage && !userName
                  ? { backgroundImage: `url(${UserRed})` }
                  : undefined
              }
              value={userName}
              onChange={(e) => setuserName(e.target.value)}
              maxLength={50}
              tabIndex={1}
            />

            <div className="divider"></div>

            <input
              type={isPasswordVisible ? "text" : "password"}
              className={`login_field login_password ${displayErrorMessage ? "red_input" : ""
                }`}
              placeholder="Password"
              style={
                displayErrorMessage
                  ? { backgroundImage: `url(${PassRed})` }
                  : undefined
              }
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              maxLength={50}
              tabIndex={2}
            />

            <span
              id="password_icon_container"
              tabIndex={3}
              role="button"
              aria-label={tooltiptext}
              onClick={togglePasswordVisibility}
              onKeyDown={handlePasswordToggleKey}
            >
              <span
                className={`show_hide_password_icon ${isPasswordVisible ? "toggle_password" : ""
                  }`}
              >
                <span className="tooltiptext">{tooltiptext}</span>
              </span>
            </span>

            {errorMessage && (
              <p id="alert_text" className="flash">
                {errorMessage}
              </p>
            )}

            <div className="button_box" style={{ marginTop: "18px", height: "115px" }}>
              <button
                id="login_btnT"
                className="general_btn two_btnT"
                type="submit"
                tabIndex={4}
                style={{
                  color: "white",
                  fontSize: "20px",
                  fontWeight: "bold",
                  width: "30%",
                }}
              >
                Log In
              </button>
            </div>

            <p className="page_text_sml">
              <span
                id="hlinkForgotPassword"
                className="page_link"
                tabIndex={5}
                onClick={handleForgotPassword}
              >
                Forgotten my password
              </span>

              <span
                id="helplines_link"
                className="page_link"
                tabIndex={6}
                onClick={() => setShowHelplines(true)}
              >
                &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;Helplines
              </span>

              <span className="text_breaker"></span>

              <span id="hlinkSchoolUser" className="page_link" tabIndex={7}>
                <span
                  id="login_school_link"
                  className="page_link"
                  onClick={handleSchoolLogin}
                >
                  <span id="school_icon"></span>School users log in here
                </span>
              </span>
            </p>
          </div>
        </div>
      </div>

      {loading && <Loading />}
    </form>
  );
};

export default FamilyLogin;
